export type ErrorCode =
  | "unexpected_failure"
  | "validation_failed"
  | "bad_json"
  | "email_exists"
  | "phone_exists"
  | "bad_jwt"
  | "not_admin"
  | "no_authorization"
  | "user_not_found"
  | "session_not_found"
  | "session_expired"
  | "refresh_token_not_found"
  | "refresh_token_already_used"
  | "flow_state_not_found"
  | "flow_state_expired"
  | "signup_disabled"
  | "user_banned"
  | "provider_email_needs_verification"
  | "invite_not_found"
  | "bad_oauth_state"
  | "bad_oauth_callback"
  | "oauth_provider_not_supported"
  | "unexpected_audience"
  | "single_identity_not_deletable"
  | "email_conflict_identity_not_deletable"
  | "identity_already_exists"
  | "email_provider_disabled"
  | "phone_provider_disabled"
  | "too_many_enrolled_mfa_factors"
  | "mfa_factor_name_conflict"
  | "mfa_factor_not_found"
  | "mfa_ip_address_mismatch"
  | "mfa_challenge_expired"
  | "mfa_verification_failed"
  | "mfa_verification_rejected"
  | "insufficient_aal"
  | "captcha_failed"
  | "saml_provider_disabled"
  | "manual_linking_disabled"
  | "sms_send_failed"
  | "email_not_confirmed"
  | "phone_not_confirmed"
  | "reauth_nonce_missing"
  | "saml_relay_state_not_found"
  | "saml_relay_state_expired"
  | "saml_idp_not_found"
  | "saml_assertion_no_user_id"
  | "saml_assertion_no_email"
  | "user_already_exists"
  | "sso_provider_not_found"
  | "saml_metadata_fetch_failed"
  | "saml_idp_already_exists"
  | "sso_domain_already_exists"
  | "saml_entity_id_mismatch"
  | "conflict"
  | "provider_disabled"
  | "user_sso_managed"
  | "reauthentication_needed"
  | "same_password"
  | "reauthentication_not_valid"
  | "otp_expired"
  | "otp_disabled"
  | "identity_not_found"
  | "weak_password"
  | "over_request_rate_limit"
  | "over_email_send_rate_limit"
  | "over_sms_send_rate_limit"
  | "bad_code_verifier"
  | "anonymous_provider_disabled"
  | "hook_timeout"
  | "hook_timeout_after_retry"
  | "hook_payload_over_size_limit"
  | "hook_payload_invalid_content_type"
  | "request_timeout"
  | "mfa_phone_enroll_not_enabled"
  | "mfa_phone_verify_not_enabled"
  | "mfa_totp_enroll_not_enabled"
  | "mfa_totp_verify_not_enabled"
  | "mfa_webauthn_enroll_not_enabled"
  | "mfa_webauthn_verify_not_enabled"
  | "mfa_verified_factor_exists"
  | "invalid_credentials"
  | "email_address_not_authorized"
  | "email_address_invalid";

// TODO: TRANSLATE
export const errorMessageTranslator = (error: ErrorCode, page?: string) => {
  switch (error) {
    case "unexpected_failure":
      return "Neočakávaná chyba";
    case "validation_failed":
      if (page === "forgot-password") {
        return "Neplatný formát e-mailu";
      }
      if (page === "sign-up") {
        return "Neplatný formát e-mailu";
      }
      return "Neplatné prihlasovacie údaje";
    case "bad_json":
      return "Neplatný formát JSON";
    case "email_exists":
      return "E-mailová adresa už existuje";
    case "phone_exists":
      return "Telefónne číslo už existuje";
    case "bad_jwt":
      return "Neplatný token";
    case "not_admin":
      return "Používateľ nemá administrátorské oprávnenia";
    case "no_authorization":
      return "Chýba autorizácia";
    case "user_not_found":
      return "Používateľ nebol nájdený";
    case "session_not_found":
      return "Relácia nebola nájdená";
    case "session_expired":
      return "Relácia vypršala";
    case "refresh_token_not_found":
      return "Obnovovací token nebol nájdený";
    case "refresh_token_already_used":
      return "Obnovovací token už bol použitý";
    case "flow_state_not_found":
      return "Stav procesu nebol nájdený";
    case "flow_state_expired":
      return "Stav procesu vypršal";
    case "signup_disabled":
      return "Registrácia je zakázaná";
    case "user_banned":
      return "Používateľ bol zablokovaný";
    case "provider_email_needs_verification":
      return "E-mailový poskytovateľ vyžaduje overenie";
    case "invite_not_found":
      return "Pozvánka nebola nájdená";
    case "bad_oauth_state":
      return "Neplatný OAuth stav";
    case "bad_oauth_callback":
      return "Neplatný OAuth callback";
    case "oauth_provider_not_supported":
      return "OAuth poskytovateľ nie je podporovaný";
    case "unexpected_audience":
      return "Neočakávané publikum";
    case "single_identity_not_deletable":
      return "Jednotná identita sa nedá odstrániť";
    case "email_conflict_identity_not_deletable":
      return "Identitu kvôli konfliktu e-mailu nie je možné odstrániť";
    case "identity_already_exists":
      return "Identita už existuje";
    case "email_provider_disabled":
      return "E-mailový poskytovateľ je zakázaný";
    case "phone_provider_disabled":
      return "Telefónny poskytovateľ je zakázaný";
    case "too_many_enrolled_mfa_factors":
      return "Príliš veľa zaregistrovaných MFA faktorov";
    case "mfa_factor_name_conflict":
      return "Konflikt názvu MFA faktora";
    case "mfa_factor_not_found":
      return "MFA faktor nebol nájdený";
    case "mfa_ip_address_mismatch":
      return "Nesúlad IP adresy pri MFA";
    case "mfa_challenge_expired":
      return "MFA výzva vypršala";
    case "mfa_verification_failed":
      return "Overenie MFA zlyhalo";
    case "mfa_verification_rejected":
      return "Overenie MFA bolo zamietnuté";
    case "insufficient_aal":
      return "Nedostatočná úroveň autentifikácie";
    case "captcha_failed":
      return "CAPTCHA zlyhala";
    case "saml_provider_disabled":
      return "SAML poskytovateľ je zakázaný";
    case "manual_linking_disabled":
      return "Manuálne prepojenie je zakázané";
    case "sms_send_failed":
      return "Odoslanie SMS zlyhalo";
    case "email_not_confirmed":
      return "E-mail nebol potvrdený. Skontrolujte svoju emailovú schránku. Mohlo sa stať, že mail prišiel do spamu.";
    case "phone_not_confirmed":
      return "Telefón nebol potvrdený";
    case "reauth_nonce_missing":
      return "Chýba nonce pri opätovnom overení";
    case "saml_relay_state_not_found":
      return "SAML relay stav nebol nájdený";
    case "saml_relay_state_expired":
      return "SAML relay stav vypršal";
    case "saml_idp_not_found":
      return "SAML IdP nebol nájdený";
    case "saml_assertion_no_user_id":
      return "SAML tvrdenie neobsahuje ID používateľa";
    case "saml_assertion_no_email":
      return "SAML tvrdenie neobsahuje e-mail";
    case "user_already_exists":
      return "Používateľ už existuje";
    case "sso_provider_not_found":
      return "SSO poskytovateľ nebol nájdený";
    case "saml_metadata_fetch_failed":
      return "Načítanie SAML metadát zlyhalo";
    case "saml_idp_already_exists":
      return "SAML IdP už existuje";
    case "sso_domain_already_exists":
      return "SSO doména už existuje";
    case "saml_entity_id_mismatch":
      return "Nesúlad SAML Entity ID";
    case "conflict":
      return "Konflikt údajov";
    case "provider_disabled":
      return "Poskytovateľ je zakázaný";
    case "user_sso_managed":
      return "Používateľ je spravovaný cez SSO";
    case "reauthentication_needed":
      return "Je potrebné opätovné overenie";
    case "same_password":
      return "Zadané heslo je rovnaké ako predchádzajúce";
    case "reauthentication_not_valid":
      return "Opätovné overenie nie je platné";
    case "otp_expired":
      return "OTP kód vypršal";
    case "otp_disabled":
      return "OTP je zakázané";
    case "identity_not_found":
      return "Identita nebola nájdená";
    case "weak_password":
      return "Heslo musí obsahovať aspoň jeden číslo";
    case "over_request_rate_limit":
      return "Prekročený limit požiadaviek";
    case "over_email_send_rate_limit":
      return "Prekročený limit odosielania e-mailov";
    case "over_sms_send_rate_limit":
      return "Prekročený limit odosielania SMS";
    case "bad_code_verifier":
      return "Neplatný overovací kód";
    case "anonymous_provider_disabled":
      return "Chýbajúca emailová adresa";
    case "hook_timeout":
      return "Vypršal časový limit webhooku";
    case "hook_timeout_after_retry":
      return "Vypršal časový limit po opätovnom pokuse webhooku";
    case "hook_payload_over_size_limit":
      return "Webhook payload prekročil limit veľkosti";
    case "hook_payload_invalid_content_type":
      return "Neplatný obsahový typ webhooku";
    case "request_timeout":
      return "Vypršal časový limit požiadavky";
    case "mfa_phone_enroll_not_enabled":
      return "Registrácia MFA cez telefón nie je povolená";
    case "mfa_phone_verify_not_enabled":
      return "Overenie MFA cez telefón nie je povolené";
    case "mfa_totp_enroll_not_enabled":
      return "Registrácia MFA cez TOTP nie je povolená";
    case "mfa_totp_verify_not_enabled":
      return "Overenie MFA cez TOTP nie je povolené";
    case "mfa_webauthn_enroll_not_enabled":
      return "Registrácia MFA cez WebAuthn nie je povolená";
    case "mfa_webauthn_verify_not_enabled":
      return "Overenie MFA cez WebAuthn nie je povolené";
    case "mfa_verified_factor_exists":
      return "Overený MFA faktor už existuje";
    case "invalid_credentials":
      return "Neplatné prihlasovacie údaje";
    case "email_address_not_authorized":
      return "E-mailová adresa nie je autorizovaná";
    case "email_address_invalid":
      return "Neplatná e-mailová adresa";
    default:
      return "Neznáma chyba";
  }
};

export const isPasswordValid = (password: string) => {
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{6,}$/;
  return passwordRegex.test(password);
};
